import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/store'
import Errors from '@/utils/Errors'

const $axios = axios.create({
    baseURL: `${process.env.API_SERVER}/api/v1`,
})

$axios.interceptors.request.use(config => {
    if (!config.quiet)
        document.getElementsByTagName('body')[0].classList.remove('loaded')

    if (store.getters.authLoggedIn)
    {
        config.headers.common['Authorization'] = `Bearer ${store.getters.authToken}`
    }
    return config
}, error => Promise.reject(error))

$axios.interceptors.response.use(c => {
        document.getElementsByTagName('body')[0].classList.add('loaded')
        return c
    }, e => {
        document.getElementsByTagName('body')[0].classList.add('loaded')
        const status = e && e.response && e.response.status ? e.response.status : 600
        switch(status)
        {
            case 503:
                store.dispatch('notify', {
                    type: 'error',
                    title: 'BASE.ERROR',
                    message: 'BASE.ERROR_DEPLOY'
                })
                break

            case 500:
                store.dispatch('notify', {
                    type: 'error',
                    title: 'BASE.ERROR',
                    message: 'BASE.ERROR_BACKEND'
                })
                break

            case 429:
                store.dispatch('notify', {
                    type: 'warning',
                    title: 'BASE.ERROR',
                    message: 'BASE.ERROR_THROTTLED'
                })
                break

            case 422:
                const errors = e && e.response && e.response.data && e.response.data.errors ? e.response.data.errors : []
                e.errors = new Errors()
                e.errors.set(errors)
                if (e.errors.hasErrors())
                {
                    store.dispatch('notify', {
                        type: 'warning',
                        title: 'BASE.ERROR',
                        native_message: e.errors.first()
                    })
                }
                break
        }
        return Promise.reject(e)
})

Vue.use(VueAxios, $axios)



// WEBPACK FOOTER //
// ./src/plugins/http.js